/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type COMMENT_SORT = "CREATED_AT_ASC" | "CREATED_AT_DESC" | "REACTION_DESC" | "REPLIES_DESC" | "%future added value";
export type FeaturedCommentsQueryLocal = {
    readonly storyID: string | null;
    readonly storyURL: string | null;
    readonly commentsOrderBy: COMMENT_SORT;
    readonly " $refType": "FeaturedCommentsQueryLocal";
};
export type FeaturedCommentsQueryLocal$data = FeaturedCommentsQueryLocal;
export type FeaturedCommentsQueryLocal$key = {
    readonly " $data"?: FeaturedCommentsQueryLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"FeaturedCommentsQueryLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "FeaturedCommentsQueryLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "storyID",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "storyURL",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "commentsOrderBy",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = '6464768ab6c5d4841f0015abcabce7a3';
export default node;
